import stockReturn from '@js/store/modules/stock-return';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('stockReturn', ['stockReturn', 'hasFinalized']),

        canUpdate() {
            return this.can(this.permission.SAVE_STOCK_RETURN);
        },

        canEdit() {
            return this.canUpdate && !this.hasFinalized;
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stockReturn')) {
            this.$store.registerModule('stockReturn', stockReturn);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_return/stock-return-mixin.js